var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!['login'].includes(_vm.$route.name))?_c('app-navigation'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }